// extracted by mini-css-extract-plugin
module.exports = {"root":"column_root__MY0Sy","blok-big-title":"column_blok-big-title__v_9RW","blok-title":"column_blok-title__KOo2p","blok-subtitle":"column_blok-subtitle__2ST0y"};